import Phaser from 'phaser';
import { PlayerController } from '../Entities/PlayerController';
import { AudioManager } from './AudioManager';

export class CollectibleSystem {
  private scene: Phaser.Scene;
  public coinGroup: Phaser.Physics.Arcade.StaticGroup;
  public gemGroup: Phaser.Physics.Arcade.StaticGroup;

  public coinsCollected = 0;
  public gemsCollected = 0;

  constructor(scene: Phaser.Scene) {
    this.scene = scene;
    this.coinGroup = scene.physics.add.staticGroup();
    this.gemGroup = scene.physics.add.staticGroup();
  }

  public spawnCollectibles(coinsData: { x: number; y: number }[], gemsData: { x: number; y: number }[]): void {
    coinsData.forEach((pos) => {
      const coin = this.coinGroup.create(pos.x, pos.y, 'coin') as Phaser.Physics.Arcade.Sprite;
      coin.setDepth(20);
      this.scene.tweens.add({
        targets: coin,
        y: pos.y - 6,
        duration: 1000,
        yoyo: true,
        repeat: -1,
        ease: 'Sine.easeInOut',
      });
    });

    gemsData.forEach((pos) => {
      const gem = this.gemGroup.create(pos.x, pos.y, 'gem') as Phaser.Physics.Arcade.Sprite;
      gem.setDepth(20);
      this.scene.tweens.add({
        targets: gem,
        y: pos.y - 8,
        duration: 1200,
        yoyo: true,
        repeat: -1,
        ease: 'Sine.easeInOut',
      });
    });
  }

  public collectCoin(player: PlayerController, coin: Phaser.GameObjects.GameObject): void {
    const sprite = coin as Phaser.Physics.Arcade.Sprite;
    if (!sprite.active) return;

    this.coinsCollected++;
    AudioManager.playSFX('coin');

    // Float & Fade Pickup Effect
    this.scene.tweens.add({
      targets: sprite,
      y: sprite.y - 24,
      alpha: 0,
      scaleX: 1.4,
      scaleY: 1.4,
      duration: 250,
      onComplete: () => {
        sprite.destroy();
      },
    });
  }

  public collectGem(player: PlayerController, gem: Phaser.GameObjects.GameObject): void {
    const sprite = gem as Phaser.Physics.Arcade.Sprite;
    if (!sprite.active) return;

    this.gemsCollected++;
    AudioManager.playSFX('gem');

    // Float & Spin Pickup Effect
    this.scene.tweens.add({
      targets: sprite,
      y: sprite.y - 30,
      alpha: 0,
      angle: 360,
      duration: 300,
      onComplete: () => {
        sprite.destroy();
      },
    });
  }
}
